import { HomeAPIList, OsmAPIList } from '@/api'
const api = new HomeAPIList();
const osmAPI = new OsmAPIList();

export default {


  // Static Store List Module 


   createStaticStore({state},param){
  return new Promise((resolve, reject) => {
      api.createStaticStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     getStaticStoreList({state},param){
  return new Promise((resolve, reject) => {
      api.getStaticStoreList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     updateStaticStore({state},param){
  return new Promise((resolve, reject) => {
      api.updateStaticStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     deleteStaticStore({state},param){
  return new Promise((resolve, reject) => {
      api.deleteStaticStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

   exportStaticStore({state},param){
  return new Promise((resolve, reject) => {
      api.exportStaticStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

   createFinalStore({state},param){
  return new Promise((resolve, reject) => {
      api.createFinalStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     getFinalStoreList({state},param){
  return new Promise((resolve, reject) => {      
      let params = {
          ...param,
          "version": 10          
        }

      api.getFinalStoreList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     updateFinalStore({state},param){
  return new Promise((resolve, reject) => {
      api.updateFinalStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
     deleteFinalStore({state},param){
  return new Promise((resolve, reject) => {
      api.deleteFinalStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

   exportFinalStore({state},param){
  return new Promise((resolve, reject) => {
      api.exportFinalStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },



  // Merchant Management
   sendSMS({state},param){
  return new Promise((resolve, reject) => {
      api.sendSMS(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  previewMessage({state},param){
    return new Promise((resolve, reject) => {
        api.previewMessage(param, (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        });
      });
    },
    reconnectCustomer({state},param){
    return new Promise((resolve, reject) => {
        api.reconnectCustomer(param, (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        });
      });
    },
    tailorMessage({state},param){
    return new Promise((resolve, reject) => {
        api.tailorMessage(param, (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        });
      });
    },

  // getMerchantList
   getMerchantList({state},param){
  return new Promise((resolve, reject) => {
      api.getMerchantList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  // createMerchant
   createMerchant({state},param){
  return new Promise((resolve, reject) => {
      api.createMerchant(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  // getStoreList getBISelections('storeList')

  getStoreList({state},param){
  return new Promise((resolve, reject) => {
      api.getStoreList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },


  // createStore
     createStore({state},param){
  return new Promise((resolve, reject) => {
      api.createStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  // updateStore
       updateStore({state},param){
  return new Promise((resolve, reject) => {
      api.updateStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  // deleteStore

       deleteStore({state},param){
  return new Promise((resolve, reject) => {
      api.deleteStore(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },


  // Biotrue CMS: Redemption
 getRedemptionList({state},param){
  return new Promise((resolve, reject) => {
      api.getRedemptionList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  deleteRedemptionRecord({ state }, param) {
    return new Promise((resolve, reject) => {
      api.deleteRedemptionRecord(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },



  // Biotrue CMS: Registration 
  BIExportCSV({state},param){
    return new Promise((resolve, reject) => {
      api.BIExportCSV(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });

  },

  // redeemBIRecord({ state }, param) {
  //   return new Promise((resolve, reject) => {
  //     api.redeemBIRecord(param, (json) => {
  //       resolve(json);
  //     }, (err) => {
  //       reject(err);
  //     });
  //   });
  // },



  deleteBIRecord({ state }, param) {
    return new Promise((resolve, reject) => {
      api.deleteBIRecord(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getRegistrationList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getRegistrationList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },


  getBISelections({state},param){
  return new Promise((resolve, reject) => {
      api.getBISelections(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },













  getMessageList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getMessageList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getRenewalList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getRenewalList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBirthdayList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBirthdayList(param, (json) => {
        json.status === 200 ? resolve(json.data) : reject(json.message);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBulletinList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBulletinDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinDetail(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getDashboardCharts({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getDashboardCharts(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getCustomerPolicyList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCustomerPolicyList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getPolicyDetail({ state }, params) {
    if (params.policyType == 'G') {
      return new Promise((resolve, reject) => {
        osmAPI.getGIDetail(params.ID, true, (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        });
      })
    } else {
      return new Promise((resolve, reject) => {
        osmAPI.getLifeDetail(params.ID, true, (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        });
      })
    }
  },


  getCaseTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCaseTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getFycTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getFycTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getCommTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCommTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  getAvailableTimeslot({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getAvailableTimeslot(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },
  rescheduleRegistration({ state }, params) {
    return new Promise((resolve, reject) => {
      api.rescheduleRegistration(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },


}



// WEBPACK FOOTER //
// ./src/Homepage/store/actions.js